import React, { useEffect } from "react";

import { showApiError } from "../utils/errorRoutingUtils";
import { useHistory } from "react-router-dom";

import shallow from "zustand/shallow";
import useCurrentAccountStore from "./AccountStore";
import useAccountDefaultStore from "./AccountDefaultsStore";
import { getAccountDetails, getAcctDefaults } from "./AccountAPI";
import useSetAccount from "./useSetAccount";
import AccountTabs from "./AccountTabs";
import { PATHS } from "../constants/Constants";
import { retrieveFailAlert } from "../utils/alertUtils";
import useRoute from "../hooks/useRoute";
import { useFromUser } from "../stores/LocalStorageHelper";
import AccountActionBar from "./AccountActionBar";
import Loading from "../components/loadingSpinner/Loading";
const AccountDetailPage = (prop) => {
	const { editAcctDefaults } = useAccountDefaultStore(
		(state) => state,
		shallow
	);
	const acctID = prop.location.state?.acctID;
	const acctListPage = useRoute(PATHS.ACCT_LIST);
	const acctAddPage = useRoute(PATHS.ACCT_ADD);
	const history = useHistory();
	const locationID = useFromUser("locationID");

	const setAccount = useSetAccount();

	// Account store
	const {
		isLoading,
		resetAcct,
		editIsLoading,
		// editAccount,
	} = useCurrentAccountStore(
		(state) => ({
			//editAccount: state.editAccount,
			isLoading: state.isLoading,
			resetAcct: state.reset,
			editIsLoading: state.editIsLoading,
		}),
		shallow
	);

	const getData = () => {
		if (acctID != null) {
			Promise.all([
				getAcctDefaults(locationID),
				getAccountDetails(acctID),
			]).then(
				(res) => {
					editAcctDefaults(res[0].data.content);

					setAccount(res[1]);

					editIsLoading(false);
				},
				(err) => {
					if (!err.isGeneralError) {
						showApiError(err, retrieveFailAlert);
						history.push(acctListPage);
					}
				}
			);
		} else {
			history.push(acctAddPage);
		}
	};
	useEffect(() => {
		if (isLoading) {
			getData();
		}
		return () => {
			resetAcct();
		};

		// eslint-disable-next-line
	}, []);

	return (
		<div>
			<div className="col-md-12 px-0 content">
				{(isLoading && <Loading />) || (
					<>
						<AccountActionBar />
						<AccountTabs />
					</>
				)}
			</div>
		</div>
	);
};

export default AccountDetailPage;
